import type { IUser } from "src/model/model";

export const getUserPreferences = ({ currentUser }: { currentUser?: IUser }) => {
  try {
    if (currentUser && Object.prototype.hasOwnProperty.call(currentUser, "preferences")) {
      return typeof currentUser.preferences === "string"
        ? JSON.parse(currentUser.preferences)
        : currentUser.preferences;
    }
  } catch {
    return null;
  }
};
